<template>
  <div
    id="queue-item"
    :class="{
      'queue-item': true,
      'no-borders': !isBordersRounded && order.status == 'executed',
      'card-no-buttons': !isBordersRounded,
      'normal-borders': order.status == 'editing'
    }"
  >
    <ItemStatus :order="order" :splitting="splitting" :cafe="cafe" />

    <div class="content">
      <ItemList
        mode="stock"
        :list="order.list.filter(item => item.append_index == null)"
        @toggleAvailability="emitToggleAvailability"
        v-if="order.status === 'waiting'"
      />

      <ItemList
        mode="view"
        :list="order.list.filter(item => item.append_index == null)"
        v-if="order.status === 'serving' || order.status === 'served'"
      />

      <ItemList
        mode="view"
        :list="order.list.filter(item => item.append_index == null)"
        v-if="order.status === 'unpaid'"
      />

      <ItemList
        mode="view"
        :list="order.list.filter(item => item.append_index == null)"
        :splitting="splitting"
        @splitClick="emitSplitClick"
        v-if="order.status === 'paying'"
      />

      <ItemList
        mode="edit"
        :list="order.list.filter(item => item.append_index == null)"
        @toggleAvailability="emitToggleAvailability"
        @changeQuantity="emitChangeQuantity"
        v-if="order.status === 'editing'"
      />

      <ItemList
        mode="view"
        :list="order.list"
        v-if="order.status === 'executed'"
      />

      <div v-if="order.appends && order.appends.length > 0">
        <div
          class="append-container"
          v-for="(append, index) in order.appends"
          :key="index"
        >
          <div v-if="append.status === 'serving'">
            <ItemStatus :order="makeAppendObject(append)" :cafe="cafe" append />
            <ItemList
              mode="view"
              :list="append.list"
              v-if="order.status !== 'editing'"
            />
            <ItemList
              mode="edit"
              :list="append.list"
              @changeQuantity="
                (idx, value) => emitAppendChangeQuantity(index, idx, value)
              "
              v-if="order.status === 'editing'"
            />
          </div>
        </div>
      </div>

      <div class="comment" v-if="order.comment">
        <h6 class="color-grey">{{ $t("card.comment") }}</h6>
        <p>{{ order.comment }}</p>
      </div>

      <div class="comment" v-if="!order.geolocation_verified && order.status == 'waiting'">
        <h6 class="color-red">{{ $t("card.geolocation_not_verified") }}</h6>
      </div>

      <div v-if="order.status == 'paying'" class="total-block">
        <h4 class="total">{{ $t("card.total") }}</h4>
        <span class="amount">{{ order.total }}{{ currency.symbol }}</span>
      </div>

      <!-- <div v-if="splitting" class="split-actions">
        <QueueButton variant="cancel" @click="emitCancel"><img src="/icons/del.svg" class="del"></QueueButton>
        <QueueButton variant="accept" class="w-80" @click="emitSplit">
          {{ $t('split.confirm') }}
        </QueueButton>
      </div>-->
    </div>

    <div v-if="order.status === 'waiting'">
     
      <AcceptTimeControls
        :class="order.comment ? 'space-top-20':'pt-0'"
        :times="suggestedWaitingTimes"
        v-model="waiting_time"/>
      <small class="info">{{ $t('waiting.not_required') }}</small>
    </div>

    <div v-if="order.status == 'executed'" class="total-block total-block-executed">
      <h4 class="total">{{ $t('card.total') }}</h4>
      <span class="amount">{{ order.total }}{{currency.symbol}}</span>
      <h5 class="color-grey pt-15" v-if="order.discount">
        {{ $t("card.discount") }}
        <span class="float-right">{{ order.discount }}%</span>
      </h5>
      <!-- <h5 class="color-grey pt-15">
        {{ $t('card.pay_method') }}
        <span
          class="float-right"
        >{{ $t(`card.pay_methods.${order.pay_method}`) }}</span>
      </h5> -->
    </div>

    <ItemActions
      :order="order"
      @cancel="emitCancel"
      @accept="emitAccept"
      @edit="emitEdit"
      @pay="emitPay"
      @confirmPay="emitConfirmPay"
      @discountChange="emitDiscountChange"
      @changeTable="emitChangeTable"
      @serve="emitServe"
      @merge="emitMerge"
      @split="emitSplit"
      @unlock="emitUnlock"
      @return="emitReturn"
      @finishEdit="emitFinishEdit"
      @showAddDishUI="emitShowAddDishUI"
      :hidePayment="hidePayUI"
      v-if="!readonly"
    />

    <DeleteDishModal
      @confirm="onConfirmDishRemove"
      @cancel="confirm_dish_remove.active = false"
      v-if="confirm_dish_remove.active"
    />
  </div>
</template>

<script>
import ItemStatus from "@/components/item/ItemStatus.vue";
import ItemList from "@/components/item/ItemList.vue";
import ItemActions from "@/components/item/ItemActions.vue";

import QueueButton from "@/components/QueueButton.vue";

import OrderHelpers from "@/services/order/helpers.js";

import DeleteDishModal from "@/components/modals/DeleteDishModal.vue";

import AcceptTimeControls from "@/components/item/AcceptTimeControls.vue";

export default {
  props: {
    order: Object,
    editing: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    splitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirm_dish_remove: {
        active: false,
        item_index: 0,
      },
      waiting_time: null,
      OrderHelpers,
    };
  },
  methods: {
    emitCancel() {
      this.$emit("cancel", this.order._id);
    },
    emitAccept() {
      this.$emit("accept", this.order._id, this.waiting_time || 0);
    },
    emitServe() {
      this.$emit("serve", this.order._id);
    },
    emitEdit() {
      this.$emit("edit", this.order._id);
    },
    emitPay() {
      this.$emit("pay", this.order._id);
    },
    emitSplit() {
      this.$emit("split", this.order._id);
    },
    emitUnlock() {
      this.$emit("unlock", this.order._id);
    },
    emitToggleAvailability(idx) {
      this.$emit("toggleAvailability", this.order._id, idx);
    },
    emitConfirmPay(data) {
      this.$emit("confirmPay", this.order._id, data);
    },
    emitDiscountChange(value) {
      this.$emit("discountChange", this.order._id, value);
    },
    emitChangeQuantity(idx, value) {
      if (this.order.list[idx].quantity == 1 && value == -1) {
        this.confirm_dish_remove.active = true;
        this.confirm_dish_remove.item_index = idx;
        return;
      }
      this.$emit("changeQuantity", this.order._id, idx, value);
    },
    onConfirmDishRemove() {
      this.confirm_dish_remove.active = false;
      this.$emit(
        "changeQuantity",
        this.order._id,
        this.confirm_dish_remove.item_index,
        -1
      );
    },
    emitAppendChangeQuantity(ev, idx, value) {
      this.$emit("appendChangeQuantity", ev, idx, value);
    },
    emitToggleAppendAvailability() {
      this.$emit("toggleAppendAvailability", this.order._id);
    },
    emitMerge() {
      this.$emit("merge", this.order._id);
    },
    emitChangeTable() {
      this.$emit("changeTable", this.order._id);
    },
    emitSplitClick(idx) {
      this.$emit("splitClick", this.order._id, idx);
    },
    emitReturn() {
      this.$emit("return", this.order._id);
    },
    emitAcceptWithTime(time) {
      this.$emit("accept", this.order._id, time);
    },
    emitFinishEdit() {
      this.$emit("finishEdit", this.order._id);
    },
    emitShowAddDishUI() {
      this.$emit("showAddDishUI", this.order._id);
    },
    makeAppendObject(ap) {
      return {
        list: ap.list,
        date: ap.date,
        comment: ap.comment,
        client: this.order.client,
        section: this.order.section,
        table: this.order.table,
        status: ap.status,
        processed_at: ap.processed_at || ap.date
      };
    },
  },
  computed: {
    isBordersRounded() {
      return !this.readonly && !this.editing;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    },
    suggestedWaitingTimes() {
      return this.$store.state.waiting_times.inside;
    },
    hidePayUI() {
      return this.$store.state.cafe.ui_settings.disable_queue_payment == true;
    }
  },
  components: {
    ItemStatus,
    ItemList,
    ItemActions,
    QueueButton,
    DeleteDishModal,
    AcceptTimeControls,
  },
};
</script>

<style scoped>
.time-blocks {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  text-align: center;
  margin: 0;
}

.space-top-20 {
  padding-top: 2.2vh;
}

.split-actions {
  display: flex;
  justify-content: space-between;
  padding: 0 2.5vh;
}

.time-input {
  margin-top: 1.9vh;
  outline: none;
  border: 2px solid #129b81;
  border-radius: 10vw;
  width: 100%;
  background: transparent;

  padding: 1.4vh 0;
  text-align: center;
  text-align-last: center;

  -webkit-appearance: none;
}


.w-80 {
  width: 80%;
}

.del {
  width: auto;
  height: 2.8vh;
}

.comment {
  padding: 0 5.4vw;
  margin-top: 2.5vh;
}

.pt-15 {
  padding-top: 1.9vh;
}

.comment h6 {
  font-weight: 500;
  font-size: 5vw;
  margin-bottom: 0;
}

.comment p {
  padding: 1.3vh 4vw 0;
  margin-bottom: 0;
  font-size: 4.5vw;
}

.time-blocks div {
  flex-basis: 30%;
  color: #1d1d1b;
  border: 2px solid #129b81;
  box-sizing: border-box;
  border-radius: 5vh;
  font-weight: 500;
  line-height: 0.8;
  margin: 1.7vh 0 0;
  padding: 1.9vh 0;
}

.total-block {
  line-height: 0.8;
  padding: 0 5.4vw;
  margin-top: 2.5vh;

  /* padding-bottom: 8vw; */
}

.total-block-executed {
  padding-bottom: 8vw;
  margin-top: 2.5vh;
}

.total {
  display: inline-block;
  margin: 0 !important;
  font-size: 6.5vw;
  text-align: initial;
  padding-top: 0.9vh;
  line-height: 0.8;
}

span.amount {
  float: right;
  margin-top: 0vh;
  line-height: 0.8;
  font-size: 9.6vw;
  font-weight: 500;
}

.queue-item {
  background: transparent;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2.2vh 2.2vh 3.3vh 3.3vh;
  width: 90vw;
  padding-bottom: 0vh;
  padding-bottom: 3.7vh;
  margin: 0 auto 2.5vh !important;
  position: relative;
}
 

.desktop-processing-orders div:nth-child(1) .queue-item,
.desktop-done-orders div:nth-child(1) .queue-item,
.desktop-new-orders div .queue-item {
  margin: 0 auto 2.7vh !important;
}

.normal-borders {
  border-radius: 2.5vh;
}

.queue-item.no-borders {
  border-radius: 2.5vh;
  padding-bottom: 0;
}

.waiting-controls {
  padding: 0 5.4vw;
  margin: 3.7vh auto 0;
}

h5 {
  margin-bottom: 0;
  font-size: 5.4vw;
  line-height: 0.8;
}

svg {
  color: #5a5a5a;
  margin: 3px 10px 0 0;
}

.content {
  width: 100%;
}

h3 {
  color: #1d1d1b;
  font-size: 26px;
}

.price {
  font-weight: 500;
  font-size: 24px;
  color: #1d1d1d;
}

.queue-client {
  padding-bottom: 10px;
  margin-bottom: 0;
}

.overall {
  padding: 0 5.4vw;
  margin-top: 3.7vh;
}

  div.total-block-executed {
    margin-top: 0 !important;
    padding-bottom: 0 !important;
  }
 .content {
    padding-bottom: 2.2vh;
  }

@media (min-width: 768px) {

 
  div.queue-item {
    width: 100%;
   
    border-radius: 3.3vh;
    padding-bottom: 2.083vw;
  }

  .queue-item.card-no-buttons {
    border-radius: 2.5vh !important;
    padding-bottom:2.3vh !important;
  }

  .time-blocks {
    margin-top: 0.694vw;
    padding: 0;
  }
  .time-input {
    width: 20.486vw;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
    margin-top: 0.694vw;
    padding: 1.042vw 4.826vw;
  }
  small.info {
    font-size: 0.903vw;
    line-height: 1.4vw;
  }
  h4.total {
    font-size: 1.667vw;
    line-height: 1.944vw;
  }
  span.amount {
    font-size: 2.5vw;
    line-height: 2.847vw;
  }
  div.total-block {
    padding: 0 1.389vw;
    margin-top: 1.389vw;
  }
  div.total-block h5 {
    display: none;
  }
  div.total-block-executed {
    margin-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .comment {
    padding: 0 1.389vw 2.2vh;
  }
  .comment h6 {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .comment p {
    padding: 0.694vw 0.69vw 0;
    font-size: 0.903vw;
    line-height: 1.042vw;
  }
}
</style>
